/** Shared by outreach generation and dashboard filtering. Empty statuses = all. */
export interface EngagementScope {
  statuses: string[];
  accounts: { mode: 'all' | 'include' | 'exclude'; values: string[] };
}

export const ACTIVE_ENGAGEMENT_SCOPE: EngagementScope = {
  statuses: ['Active'], accounts: { mode: 'all', values: [] },
};

export interface ScopedEngagement {
  // undefined means a legacy draft whose status was not recorded; null is a known blank.
  engagementStatus?: string | null;
  accountName: string | null;
  accountDisplayName?: string | null;
}

export function matchesEngagementScope(row: ScopedEngagement, scope: EngagementScope): boolean {
  if (scope.statuses.length && (row.engagementStatus === undefined ||
      !scope.statuses.includes(row.engagementStatus?.trim() || '(blank)'))) return false;
  const account = row.accountDisplayName?.trim() || row.accountName?.trim() || null;
  if (scope.accounts.mode === 'all') return true;
  const selected = account !== null && scope.accounts.values.includes(account);
  return scope.accounts.mode === 'include' ? selected : !selected;
}

/** Never partially hide an email body. Mixed/legacy drafts require regeneration. */
export function draftMatchesScope(rows: ScopedEngagement[], scope: EngagementScope): boolean {
  return rows.length > 0 && rows.every((row) => matchesEngagementScope(row, scope));
}
